import type { Message, MessageBody } from "../../api/messaging.api";
import type { WorkspaceReference } from "../../api/references.api";
export type InlineReference = WorkspaceReference & { token: string };
export function makeToken(label: string, refs: InlineReference[]) {
  const clean =
    label.replace(/[[\]\r\n]/g, " ").slice(0, 120) || "Objet Permio";
  let token = `#[${clean}]`,
    n = 2;
  while (refs.some((r) => r.token === token)) token = `#[${clean} · ${n++}]`;
  return token;
}
export function inlineBody(text: string, refs: InlineReference[]): MessageBody {
  const segments: MessageBody["segments"] = [];
  let rest = text;
  while (rest) {
    const matches = refs
      .map((r) => ({ r, index: rest.indexOf(r.token) }))
      .filter((x) => x.index >= 0)
      .sort((a, b) => a.index - b.index);
    const next = matches[0];
    if (!next) {
      segments.push({ kind: "text", text: rest });
      break;
    }
    if (next.index)
      segments.push({ kind: "text", text: rest.slice(0, next.index) });
    segments.push({
      kind: "reference",
      reference: { entityType: next.r.entityType, entityId: next.r.entityId },
    });
    rest = rest.slice(next.index + next.r.token.length);
  }
  return { bodyVersion: 1, segments };
}
export function editInline(message: Message) {
  const refs: InlineReference[] = [];
  const text = (message.content?.segments ?? [])
    .map((s) => {
      if (s.kind === "text") return s.text;
      const resolved = message.references.find(
        (r) =>
          r.entityType === s.reference.entityType &&
          r.entityId === s.reference.entityId,
      );
      const token = makeToken(
        resolved?.available ? resolved.label : "Objet Permio",
        refs,
      );
      refs.push({ ...s.reference, token });
      return token;
    })
    .join("");
  return { text, refs };
}
